import React, { useCallback, useContext, useEffect, useState } from 'react';
import './Components/FilterPapers.css';
import FilterPanel from './Components/FilterPanel';
import StaffFilterPanel from './Components/StaffFilterPanel';
import PaperTable from './Components/PaperTable';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Chip, Stack } from '@mui/material';
import { MainContext } from '../../../../../context/main/main-context';
import { debounce } from 'lodash';
import { ASSESSMENT_STUDENT_FILTERS } from '../../../../../helper/constants';
import { Yard } from '@mui/icons-material';
import Type from '../../../subscription/Type';
import ExamsHeaderTabs from '../ExamsHeaderTabs';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 450,
  bgcolor: 'background.paper',
  borderRadius: '16px',
  boxShadow: 24,
  p: 3,
  maxHeight: '90vh',
  overflowY: 'auto',
};

export default function PaperFilterLayout(
  { userType,
    onFilterChange,
    filterKeys = [],
    isShowExamStatus = false,
    showHeader = false,
    showFilterToggleButton = false,
    onToggleFilters,
    value,
    handleChange,
    customerPaperText,
    availablePaperControl,
    enrollPaperControl
  }) {

  const {
    assessment_filter_data_initial_loading,
    assessment_filter_data_loading,
    assessment_filter_data,
    fetchAssessmentFilterdData } = useContext(MainContext)

  const [selectedFilters, setSelectedFilters] = useState({
    Subject: [],
    Grade: [],
    Status: [],
    Source: [],
    Author: [],
    Category: [],
    Exam_Category: [],
    Chapter: [],
    Difficulty: [],
    Language: [],
    Created_By: [],
    Reviewers: [],
    Term: [],
    Exam_Status: ['null'],
    StartDate: "",
    EndDate: "",
    Year: [],
    Type: [],

  });

  const [filterOptions, setFilterOptions] = useState(assessment_filter_data)



  const [visibleFilterOptions, setVisibleFilterOptions] = useState([])

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handlefetchAllMyAssessments = useCallback(
    debounce(async () => {

      try {

        await fetchAssessmentFilterdData();

      } catch (error) {
        console.error('Error fetching assessments filter data', error);
      }
    }, 300),
    []);

  useEffect(() => {

    handlefetchAllMyAssessments()

  }, []);

  useEffect(() => {
    if (assessment_filter_data && assessment_filter_data.length > 0) {
      const parsedFilters = {};

      assessment_filter_data.forEach((item) => {
        const key = Object.keys(item)[0];
        parsedFilters[key] = item[key];
      });


      parsedFilters["Exam_Status"] = [
        {
          exam_status: "All",
          exam_status_id: "null"
        },
        {
          exam_status: "Not Started",
          exam_status_id: "Upcoming"
        },
        {
          exam_status: "Started",
          exam_status_id: "Onprogress"
        },
        {
          exam_status: "Completed",
          exam_status_id: "Finished"
        },
      ]


      setFilterOptions(parsedFilters);
    }
  }, [assessment_filter_data]);

  // Auto set filters based on user type
  useEffect(() => {
    if (userType === "student") {
      const user_grade = Number(sessionStorage.getItem("studentGrade"));
      const user_medium = Number(sessionStorage.getItem("studentMedium"));

      setSelectedFilters((prev) => ({
        ...prev,
        Grade: prev.Grade?.includes(user_grade)
          ? prev.Grade
          : [...(prev.Grade || []), user_grade],
        Language: prev.Language?.includes(user_medium)
          ? prev.Language
          : [...(prev.Language || []), user_medium],
      }));

      // } else if (userType === "TEACH") {
      //   const user_subject = Number(sessionStorage.getItem("teacherSubject"));

      //   setSelectedFilters((prev) => ({
      //     ...prev,
      //     Subject: prev.Subject?.includes(user_subject)
      //       ? prev.Subject
      //       : [...(prev.Subject || []), user_subject],
      //   }));

    }
  }, [userType, assessment_filter_data]);

  // Decide visible filter options based on user type
  useEffect(() => {
    // Add StartDate and EndDate so they can be controlled by filterKeys prop
    const availableFilterKeys = [...Object.keys(filterOptions || {}), 'StartDate', 'EndDate'];
    let visibleFilterKeys = availableFilterKeys;

    visibleFilterKeys = filterKeys.filter((key) =>
      availableFilterKeys.includes(key)
    )



    // if (userType === "student" || userType === "parent") {
    //   visibleFilterKeys = availableFilterKeys.filter((key) =>
    //     ASSESSMENT_STUDENT_FILTERS.includes(key)
    //   );
    // } else if (userType === "DEOP" || userType === "TEACH"||userType==="MASAD") {
    //   if (userType === "TEACH") {
    //     const mainFilters = [
    //       "Grade",
    //       "Subject",
    //       "Language",
    //       "Status",


    //     ];
    //     visibleFilterKeys = availableFilterKeys.filter((key) =>
    //       mainFilters.includes(key)
    //     );
    //   } else if (userType === "DEOP"||userType==="MASAD") {
    //     visibleFilterKeys = availableFilterKeys.filter((key) =>
    //       filterKeys.includes(key)
    //     )
    //   }

    // }

    setVisibleFilterOptions(visibleFilterKeys);

  }, [filterOptions, userType]);

  const handleSetSelectedFilters = (newFilters) => {

    setSelectedFilters(newFilters)
    // onFilterChange(newFilters)
  }

  const handleApplyFilters = () => {
    onFilterChange(selectedFilters)
  }

  const handleClearAllFilters = () => {
    const cleared = {};
    Object.keys(selectedFilters).forEach((key) => {
      if (isShowExamStatus && key === "Exam_Status") {
        cleared[key] = selectedFilters[key];
      } else if (key === 'StartDate' || key === 'EndDate' || key === 'StartDateRaw' || key === 'EndDateRaw') {
        cleared[key] = "";
      } else {
        cleared[key] = [];
      }
    });

    setSelectedFilters(cleared);
    onFilterChange(cleared);
  }

  // helper to delete a single chip
  const handleDeleteChip = (filterType, value) => {
    const updated = {
      ...selectedFilters,
      [filterType]: (selectedFilters[filterType] || []).filter((v) => v !== value)
    };
    setSelectedFilters(updated);
    // onFilterChange(updated);
  }

  // staff chip/label helpers
  const staffChipColorMap = {
    Exam_Category: { bg: '#FFF3E0', color: '#E65100', border: '#FFCC80' },
    Grade: { bg: '#FCE4EC', color: '#C2185B', border: '#F48FB1' },
    Language: { bg: '#E3F2FD', color: '#1565C0', border: '#90CAF9' },
    Subject: { bg: '#F3E5F5', color: '#7B1FA2', border: '#CE93D8' },
    Category: { bg: '#E8F5E9', color: '#2E7D32', border: '#A5D6A7' },
    Status: { bg: '#FFF8E1', color: '#F57F17', border: '#FFE082' },
    Year: { bg: '#E0F7FA', color: '#00838F', border: '#80DEEA' },
    Created_By: { bg: '#EDE7F6', color: '#512DA8', border: '#B39DDB' },
    Exam_Status: { bg: '#FFEBEE', color: '#C62828', border: '#EF9A9A' },
    Department: { bg: '#E8EAF6', color: '#3F51B5', border: '#9FA8DA' },
    default: { bg: '#F5F5F5', color: '#616161', border: '#E0E0E0' },
  };

  const staffFilterKeyMap = {
    Subject: { idKey: "subject_id", labelKey: "subject" },
    Grade: { idKey: "grade_id", labelKey: "grade" },
    Status: { idKey: "status_id", labelKey: "status" },
    Source: { idKey: "source_id", labelKey: "source" },
    Author: { idKey: "author_id", labelKey: "author" },
    Category: { idKey: "category_id", labelKey: "name" },
    Exam_Category: { idKey: "exam_category_id", labelKey: "name" },
    Chapter: { idKey: "chapter_id", labelKey: "chapter" },
    Difficulty: { idKey: "difficulty_id", labelKey: "difficulty_type" },
    Language: { idKey: "language_id", labelKey: "language" },
    Created_By: { idKey: "created_by_id", labelKey: (item) => `${item.first_name} ${item.last_name}` },
    Reviewers: { idKey: "user_id", labelKey: (item) => `${item.first_name} ${item.last_name}` },
    Term: { idKey: "term_id", labelKey: "term" },
    Exam_Status: { idKey: "exam_status_id", labelKey: "exam_status" },
    Year: { idKey: "year_id", labelKey: "year" },
    Type: { idKey: "type_id", labelKey: "qtype" },
    Department: { idKey: "department_id", labelKey: "department_name" }
  };

  const renderStaffChips = () => (
    <Stack direction="row" spacing={0.5} className="staff-selected-chips-row" sx={{ flexWrap: 'wrap', marginBottom: '8px' }}>
      {visibleFilterOptions
        ?.filter(filterType => filterType !== 'StartDate' && filterType !== 'EndDate' && (isShowExamStatus || filterType !== "Exam_Status"))
        .flatMap((filterType) => {
          const chipColors = staffChipColorMap[filterType] || staffChipColorMap.default;
          const config = staffFilterKeyMap[filterType];
          return (selectedFilters[filterType] || []).map((value) => {
            const item = (filterOptions[filterType] || []).find(opt => opt[config?.idKey] === value);
            const label = typeof config?.labelKey === 'function' ? config.labelKey(item) : item?.[config?.labelKey] || value;

            return (
              <Chip
                key={`${filterType}-${value}`}
                label={label}
                onDelete={filterType !== "Exam_Status" ? () => handleDeleteChip(filterType, value) : undefined}
                size="small"
                className="staff-selected-chip"
                sx={{
                  backgroundColor: chipColors.bg,
                  color: chipColors.color,
                  border: `1px solid ${chipColors.border}`,
                  fontWeight: 600,
                  height: 'auto',
                  fontSize: 10,
                  padding: '1px 4px',
                  boxShadow: 'none',
                }}
              />
            );
          });
        })}
    </Stack>
  );
  // Determine if user is staff (MASAD, DEOP, TEACH)
  const isStaffUser = userType === "MASAD" || userType === "DEOP" || userType === "TEACH";

  // Choose the appropriate filter component
  const FilterComponent = isStaffUser ? StaffFilterPanel : FilterPanel;

  return (

    <div className="">

      <ExamsHeaderTabs
        showHeader={showHeader}
        value={value}
        handleChange={handleChange}
        customerPaperText={customerPaperText}
        availablePaperControl={availablePaperControl}
        enrollPaperControl={enrollPaperControl}
      />

      <div className='MobileFilter'>
        <div className="d-md-none text-start px-0 pt-0 ml-4">
          <button
            onClick={handleOpen}
            className="btn ph-filter-toggle-button"
            aria-label="Open Filters"
          >
            <TuneRoundedIcon className="ph-filter-icon" />
            <span className="ph-filter-text">Filters</span>
          </button>
        </div>

        {/* Desktop filters for staff users - no separate clear button/chips */}


        <Modal open={open} onClose={handleClose}>
          <Box sx={modalStyle}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center">
                <p className="mobfilTopic">Filters</p>
              </div>

              <IconButton
                onClick={handleClose}
                size="small"
                aria-label="close"
                sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  color: '#333',
                }}
              >
                <CloseIcon />
              </IconButton>

              <button
                className="btn-close"
                onClick={handleClose}
                style={{ border: 'none', background: 'none' }}
                aria-label="Close"
              />
            </div>

            {isStaffUser && renderStaffChips()}

            <FilterComponent
              userType={userType}
              selectedFilters={selectedFilters}
              setSelectedFilters={handleSetSelectedFilters}
              onApplyFilters={handleApplyFilters}
              onClearAll={handleClearAllFilters}
              filterOptions={filterOptions}
              setFilterOptions={setFilterOptions}
              visibleFilterOptions={visibleFilterOptions}
              isShowExamStatus={isShowExamStatus}
              showFilterToggleButton={showFilterToggleButton}
              onToggleFilters={onToggleFilters}
            />
          </Box>
        </Modal>
      </div>


      <div className="d-none d-md-block">
        <FilterComponent
          userType={userType}
          selectedFilters={selectedFilters}
          setSelectedFilters={handleSetSelectedFilters}
          onApplyFilters={handleApplyFilters}
          onClearAll={handleClearAllFilters}
          filterOptions={filterOptions}
          setFilterOptions={setFilterOptions}
          visibleFilterOptions={visibleFilterOptions}
          isShowExamStatus={isShowExamStatus}
          showFilterToggleButton={showFilterToggleButton}
          onToggleFilters={onToggleFilters}
        />
      </div>

    </div>
  );
}
